import axios from "axios"
import IContext from './i-context';
import { Message } from 'element-ui';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 是否允许跨域
axios.defaults.withCredentials = true;

//全局变量
declare let backPath: string

export default class Axios {
    private context: IContext
    private instance: any
    private needToken: boolean
    // private API: string = api

    constructor(context: IContext, needToken: boolean = true) {
        this.context = context
        this.needToken = needToken

        // this.setApi = this.setApi.bind(this)
        this.createAxios = this.createAxios.bind(this)
        this.tokenGetter = this.tokenGetter.bind(this)
        this.checkStatus = this.checkStatus.bind(this)
        this.createInstance = this.createInstance.bind(this)
        // this.checkCode = this.checkCode.bind(this)
        // this.errorCatch = this.errorCatch.bind(this)
        this.get = this.get.bind(this)
        this.post = this.post.bind(this)

        this.createAxios()
    }

    // public setApi(a: string) {
    //     this.API = a
    //     this.createAxios()
    // }

    // public getApi() {
    //     return this.API
    // }

    private createAxios() {
        this.instance = this.createInstance(this.tokenGetter)
    }

    public tokenGetter() {
        if (this.needToken)
            return this.context.getAccessToken()
        return null
    }

    private createInstance(tokenGetter: any) {
        // 延迟时间，主路由地址
        let instance = axios.create({
            // baseURL: api,
            withCredentials: true,
            timeout: 50000,
        });

        // 设置拦截器
        instance.interceptors.request.use((config: any) => {
            NProgress.start()
            //在发送请求之前做某事
            var token = tokenGetter()
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            // config.headers.client_id = `app`;
            // config.headers.client_secret = `app`;
            // config.headers.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTc2NzIwNzYsInVzZXJfbmFtZSI6ImxhaXd1IiwiYXV0aG9yaXRpZXMiOlsidXNlcjp2aWV3Iiwicm9sZTp1cGRhdGUiLCJ1c2VyOmFkZCIsInVzZXI6ZGVsZXRlIiwiZGVwdDphZGQiLCJjbGllbnQ6dXBkYXRlIiwidXNlcjp1cGRhdGUiLCJyb2xlOmFkZCIsImRlcHQ6dXBkYXRlIiwicm9sZTpleHBvcnQiLCJtZW51OnVwZGF0ZSIsIm1lbnU6YWRkIiwibWVudTpleHBvcnQiLCJkZXB0OmV4cG9ydCIsImNsaWVudDpkZWNyeXB0IiwiZGVwdDpkZWxldGUiLCJ1c2VyOmV4cG9ydCIsInJvbGU6ZGVsZXRlIiwidXNlcjpyZXNldCIsImNsaWVudDphZGQiLCJtZW51OmRlbGV0ZSIsImNsaWVudDpkZWxldGUiXSwianRpIjoiNTIxZmQ3OTYtNGI0OS00MzJmLTk5MGEtNzhiOTY1ZWM0MzAyIiwiY2xpZW50X2lkIjoiZGFwaW5nIiwic2NvcGUiOlsiYWxsIl19.Aj9poanPCar91nJ3JO3KPGqiRDJthkXocQFV8vzejHo`;
            if (config.url.indexOf("executeControl") < 0) {
                this.context.req_loading++
            }

            return config;
        }, (error: any) => {
            //请求错误时做些事
            return Promise.reject(error);
        });

        //响应拦截器
        instance.interceptors.response.use((response: any) => {
            NProgress.done()
            //对响应数据做些事
            if (response.data.code == 401) {
                Message({
                    type: "warning",
                    message: response.data.message
                });
                window.location.href = backPath ? backPath : "/login.html?web&from=logout";
            }
            return response;
        }, (error: any) => {
            //请求错误时做些事
            // var data = error.response.data
            Message({
                type: "warning",
                message: "服务超时，请稍后再试！"
            });
            return Promise.reject(error);
        });

        // 是否销毁拦截器
        // 1.给拦截器起个名称 var myInterceptors = instance.interceptors.requesst.use();
        // 2.instance.interceptors.request.eject(myInterceptor);

        return instance
    }

    // 请求成功的回调
    private checkStatus(res: any) {
        //请求结束成功
        if (res.status === 200 || res.status === 304) {
            return res.data
        }

        if (res.status == 401) {
            return { status: 401 }
        }

        return {
            code: 0,
            msg: res.data.msg || res.statusText,
            data: res.statusText
        }
    }

    // private errorCatch(e: any) {
    //     console.info("errorCatch", e)
    // }

    public get(url: any, params: any = null) {
        return this.instance({
            method: 'get',
            url: url,
            params,
            timeout: 30000
        }).then(this.checkStatus)
    }

    public post(url: any, data: any = null) {
        return this.instance({
            method: 'post',
            url: url,
            data: data,
            timeout: 30000
        }).then(this.checkStatus)
    }

    public postJson(url: any, data: any = null) {
        return this.instance({
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
            timeout: 30000
        }).then(this.checkStatus)
    }

    public postForm(url: any, data: any = null) {
        var params = []
        for (var name in data) {
            params.push(name + '=' + encodeURIComponent(data[name]))
        }

        return this.instance({
            method: 'post',
            url: url,
            data: params.join('&'),
            timeout: 30000
        }).then(this.checkStatus)
    }
    public put(url: any, data: any = null) {
        return this.instance({
            method: 'put',
            url: url,
            contentType: 'application/json',
            data: data,
            timeout: 30000
        }).then(this.checkStatus)
    }
    public putQuery(url: any, params: any = null) {
        return this.instance({
            method: 'put',
            url: url,
            params,
            timeout: 30000
        }).then(this.checkStatus)
    }
    public delete(url: any, params: any = null) {
        return this.instance({
            method: 'delete',
            url: url,
            contentType: "application/json",
            data: params,
            timeout: 30000
        }).then(this.checkStatus)
    }
}